import { v4 as uuidv4 } from 'uuid';

import { set } from 'lodash';
import {
  CREATE_SHIFT_ADD_NEW_BREAK,
  CREATE_SHIFT_CHANGE_ACTIVITY_TRACKER_MODE,
  CREATE_SHIFT_CHANGE_ACTIVITY_TRACKER_VALUE,
  CREATE_SHIFT_CHANGE_BREAKS,
  CREATE_SHIFT_CHANGE_COMMISSION_TYPE,
  CREATE_SHIFT_CHANGE_MOTION_TRACKER_MODE,
  CREATE_SHIFT_CHANGE_MOTION_TRACKER_VALUE,
  CREATE_SHIFT_CHANGE_NUMBER_IN_THE_SHIFT,
  CREATE_SHIFT_CHANGE_SELECT_WEEK_DAY,
  CREATE_SHIFT_CHANGE_SHIFT_BRANCHES,
  CREATE_SHIFT_CHANGE_SHIFT_END_TIME,
  CREATE_SHIFT_CHANGE_SHIFT_NAME,
  CREATE_SHIFT_CHANGE_SHIFT_START_TIME,
  CREATE_SHIFT_CHANGE_STEP_COUNTER_CHANGE_INDEX,
  CREATE_SHIFT_CHANGE_STEP_COUNTER_NEXT,
  CREATE_SHIFT_CHANGE_STEP_COUNTER_PREVIOUS,
  CREATE_SHIFT_CHANGE_USER_ROLES,
  CREATE_SHIFT_COMMISSION_ADD_TIER,
  CREATE_SHIFT_COMMISSION_CHANGE_TIER_VALUE,
  CREATE_SHIFT_COMMISSION_INDIVIDUAL,
  CREATE_SHIFT_COMMISSION_INDIVIDUAL_ADD,
  CREATE_SHIFT_COMMISSION_INDIVIDUAL_REMOVE,
  CREATE_SHIFT_COMMISSION_PER_VEHICLE,
  CREATE_SHIFT_COMMISSION_PER_VEHICLE_ADD,
  CREATE_SHIFT_COMMISSION_PER_VEHICLE_REMOVE,
  CREATE_SHIFT_COMMISSION_REMOVE_TIER,
  CREATE_SHIFT_COMMISSION_USER_GROUP,
  CREATE_SHIFT_COMMISSION_USER_GROUP_ADD,
  CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE,
  CREATE_SHIFT_ENTER_BREAK_NAME,
  CREATE_SHIFT_ENTER_BREAK_TIME,
  CREATE_SHIFT_ENTER_USER_ROLE,
  CREATE_SHIFT_REMOVE_BREAK,
  CREATE_SHIFT_SET_EXISTING_DATA,
  CREATE_SHIFT_RESET_STATE,
  CREATE_NEW_STEP_FILLED,
  CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_INDIVIDUAL,
  CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_PER_VEHICLE,
  CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_TEAM,
  CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_INDIVIDUAL,
  CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_PER_VEHICLE,
  CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_TEAM,
} from '../constants/create-shift.constant';
import { getTiersError } from '../helpers/create-shift.helper';

const initialState = {
  isEdit: false,
  id: null,
  stepCounter: 0,
  // STEP-1
  shiftName: '',
  branchList: [],
  // STEP-2
  dueStartTime: '',
  dueEndTime: '',
  days: {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  },
  // STEP-3
  noOfUsersOnShift: null,
  userRoles: [],
  // STEP-4
  breaks: [],
  // STEP-5
  selectedCommissionModes: [],
  // STEP-6
  commissionValuesForIndividual: {
    'Branch Manager': [
      {
        noOfVehicles: null,
        involuntary: null,
        amount: 0,
        user: 'all',
      },
    ],
    'Recovery Agent': [
      {
        noOfVehicles: null,
        involuntary: null,
        amount: 0,
        user: 'all',
      },
    ],
    Investigator: [
      {
        noOfVehicles: null,
        involuntary: null,
        amount: 0,
        user: 'all',
      },
    ],
    'Camera Car': [
      {
        noOfVehicles: null,
        involuntary: null,
        amount: 0,
        user: 'all',
      },
    ],
    Spotter: [
      {
        noOfVehicles: null,
        involuntary: null,
        amount: 0,
        user: 'all',
      },
    ],
    Administrator: [
      {
        noOfVehicles: null,
        involuntary: null,
        amount: 0,
        user: 'all',
      },
    ],
    'Customer Rep': [
      {
        noOfVehicles: null,
        involuntary: null,
        amount: 0,
        user: 'all',
      },
    ],
  },
  commissionValuesPerVehicle: {
    'Branch Manager': [{ involuntary: 0, voluntary: 0, user: 'all' }],
    'Recovery Agent': [{ involuntary: 0, voluntary: 0, user: 'all' }],
    Investigator: [{ involuntary: 0, voluntary: 0, user: 'all' }],
    'Camera Car': [{ involuntary: 0, voluntary: 0, user: 'all' }],
    Spotter: [{ involuntary: 0, voluntary: 0, user: 'all' }],
    Administrator: [{ involuntary: 0, voluntary: 0, user: 'all' }],
    'Customer Rep': [{ involuntary: 0, voluntary: 0, user: 'all' }],
  },
  tiers: [
    {
      data: [],
      commissionValuesForUserGroup: {
        'Branch Manager': [{ amount: 0, user: 'all' }],
        'Recovery Agent': [{ amount: 0, user: 'all' }],
        Investigator: [{ amount: 0, user: 'all' }],
        'Camera Car': [{ amount: 0, user: 'all' }],
        Spotter: [{ amount: 0, user: 'all' }],
        Administrator: [{ amount: 0, user: 'all' }],
        'Customer Rep': [{ amount: 0, user: 'all' }],
      },
    },
  ],
  usersWithCommissions: {},
  // STEP-7
  activityTrackerModes: {
    'Branch Manager': false,
    'Recovery Agent': false,
    Investigator: false,
    'Camera Car': false,
    Spotter: false,
    Administrator: false,
    'Customer Rep': false,
  },
  activityTrackerValues: {
    'Branch Manager': '',
    'Recovery Agent': '',
    Investigator: '',
    'Camera Car': '',
    Spotter: '',
    Administrator: '',
    'Customer Rep': '',
  },
  motionTrackerModes: {
    'Branch Manager': false,
    'Recovery Agent': false,
    Investigator: false,
    'Camera Car': false,
    Spotter: false,
    Administrator: false,
    'Customer Rep': false,
  },
  motionTrackerValues: {
    'Branch Manager': '',
    'Recovery Agent': '',
    Investigator: '',
    'Camera Car': '',
    Spotter: '',
    Administrator: '',
    'Customer Rep': '',
  },
  tierErrors: [],
  stepsFilled: [],
};

// eslint-disable-next-line react-refresh/only-export-components, complexity
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CREATE_SHIFT_CHANGE_SHIFT_NAME: {
      return {
        ...state,
        shiftName: payload,
      };
    }
    case CREATE_SHIFT_CHANGE_SHIFT_BRANCHES: {
      return {
        ...state,
        branchList: payload,
      };
    }
    case CREATE_SHIFT_CHANGE_STEP_COUNTER_NEXT: {
      return {
        ...state,
        stepCounter: state.stepCounter + 1,
      };
    }
    case CREATE_SHIFT_CHANGE_STEP_COUNTER_PREVIOUS: {
      return {
        ...state,
        stepCounter: state.stepCounter - 1,
      };
    }
    case CREATE_SHIFT_CHANGE_STEP_COUNTER_CHANGE_INDEX: {
      return {
        ...state,
        stepCounter: payload,
      };
    }
    case CREATE_SHIFT_CHANGE_SHIFT_START_TIME: {
      return {
        ...state,
        dueStartTime: payload,
      };
    }
    case CREATE_SHIFT_CHANGE_SHIFT_END_TIME: {
      return {
        ...state,
        dueEndTime: payload,
      };
    }
    case CREATE_SHIFT_CHANGE_NUMBER_IN_THE_SHIFT: {
      const updatedTier = [];

      state.tiers.forEach((tier) => {
        const tierData = [];

        for (let i = 0; i < Number(payload); i++) {
          const tierRow = tier.data[i];

          if (tierRow) {
            tierData.push({
              voluntary: tierRow.voluntary,
              involuntary: tierRow.involuntary,
            });
          } else {
            tierData.push({ voluntary: null, involuntary: null });
          }
        }

        updatedTier.push({
          data: tierData,
          commissionValuesForUserGroup: tier.commissionValuesForUserGroup,
        });
      });

      return {
        ...state,
        noOfUsersOnShift: payload,
        tiers: [...updatedTier],
      };
    }
    case CREATE_SHIFT_CHANGE_USER_ROLES: {
      return {
        ...state,
        userRoles: payload,
      };
    }
    case CREATE_SHIFT_CHANGE_BREAKS: {
      return {
        ...state,
        breaks: payload,
      };
    }
    case CREATE_SHIFT_ENTER_BREAK_NAME: {
      const { index, key, value } = payload;
      const updatedBreak = set(state.breaks, `[${index}].${key}`, value);
      return {
        ...state,
        breaks: updatedBreak,
      };
    }
    case CREATE_SHIFT_ENTER_USER_ROLE: {
      const { index, key, value } = payload;
      const updatedBreak = set(state.breaks, `[${index}].${key}`, value);
      return {
        ...state,
        breaks: updatedBreak,
      };
    }
    case CREATE_SHIFT_ADD_NEW_BREAK: {
      return {
        ...state,
        breaks: [
          ...state.breaks,
          {
            id: uuidv4(),
            breakName: '',
            userRole: '',
            breakTime: '',
          },
        ],
      };
    }
    case CREATE_SHIFT_REMOVE_BREAK: {
      const { index = 0 } = payload;
      const updatedBreaks = state.breaks.filter((a, i) => i !== index);
      return {
        ...state,
        breaks: updatedBreaks,
      };
    }
    case CREATE_SHIFT_ENTER_BREAK_TIME: {
      const { index, key, value } = payload;
      const updatedBreak = set(state.breaks, `[${index}].${key}`, value);
      return {
        ...state,
        breaks: updatedBreak,
      };
    }
    case CREATE_SHIFT_CHANGE_COMMISSION_TYPE: {
      const isAlready = state.selectedCommissionModes.includes(payload);
      let final = [];
      const { tiers } = state;
      if (isAlready) {
        final = state.selectedCommissionModes.filter((a) => a !== payload);
      } else {
        final = [...state.selectedCommissionModes, payload];
      }

      return {
        ...state,
        tiers,
        selectedCommissionModes: final,
      };
    }
    case CREATE_SHIFT_CHANGE_SELECT_WEEK_DAY: {
      return {
        ...state,
        days: {
          ...state.days,
          [payload.key]: payload.value,
        },
      };
    }
    case CREATE_SHIFT_CHANGE_ACTIVITY_TRACKER_MODE: {
      return {
        ...state,
        activityTrackerModes: {
          ...state.activityTrackerModes,
          [payload.key]: payload.value,
        },
      };
    }
    case CREATE_SHIFT_CHANGE_ACTIVITY_TRACKER_VALUE: {
      return {
        ...state,
        activityTrackerValues: {
          ...state.activityTrackerValues,
          [payload.key]: payload.value,
        },
      };
    }
    case CREATE_SHIFT_CHANGE_MOTION_TRACKER_MODE: {
      return {
        ...state,
        motionTrackerModes: {
          ...state.motionTrackerModes,
          [payload.key]: payload.value,
        },
      };
    }
    case CREATE_SHIFT_CHANGE_MOTION_TRACKER_VALUE: {
      return {
        ...state,
        motionTrackerValues: {
          ...state.motionTrackerValues,
          [payload.key]: payload.value,
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_INDIVIDUAL: {
      const { index, topKey, key, value } = payload;
      const updated = set(state.commissionValuesForIndividual, `[${topKey}].${index}.${key}`, value);
      return {
        ...state,
        commissionValuesForIndividual: updated,
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_INDIVIDUAL: {
      const { role } = payload;
      return {
        ...state,
        commissionValuesForIndividual: {
          ...state.commissionValuesForIndividual,
          [role]: [],
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_PER_VEHICLE: {
      const { role } = payload;
      return {
        ...state,
        commissionValuesPerVehicle: {
          ...state.commissionValuesPerVehicle,
          [role]: [],
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE_TEAM: {
      const { role } = payload;
      const tempTiers = [...state.tiers];

      state.tiers.forEach((tier, index) => {
        tempTiers[index] = {
          data: state.tiers[index].data,
          commissionValuesForUserGroup: {
            ...state.tiers[index].commissionValuesForUserGroup,
            [role]: [],
          },
        };
      });

      return {
        ...state,
        tiers: tempTiers,
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_INDIVIDUAL: {
      const { role } = payload;
      return {
        ...state,
        commissionValuesForIndividual: {
          ...state.commissionValuesForIndividual,
          [role]: [
            {
              noOfVehicles: null,
              involuntary: null,
              amount: 0,
              user: 'all',
            },
          ],
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_PER_VEHICLE: {
      const { role } = payload;
      return {
        ...state,
        commissionValuesPerVehicle: {
          ...state.commissionValuesPerVehicle,
          [role]: [{ involuntary: 0, voluntary: 0, user: 'all' }],
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_ADD_TEAM: {
      const { role, index } = payload;
      const tempTiers = [...state.tiers];

      if (index === undefined) return { ...state };

      tempTiers[index] = {
        data: state.tiers[index].data,
        commissionValuesForUserGroup: {
          ...state.tiers[index].commissionValuesForUserGroup,
          [role]: [{ amount: 0, user: 'all' }],
        },
      };

      return {
        ...state,
        tiers: tempTiers,
      };
    }
    case CREATE_SHIFT_COMMISSION_INDIVIDUAL_ADD: {
      const { role } = payload;
      return {
        ...state,
        commissionValuesForIndividual: {
          ...state.commissionValuesForIndividual,
          [role]: [
            ...(state.commissionValuesForIndividual[role] || []),
            {
              noOfVehicles: null,
              involuntary: null,
              amount: 0,
              user: null,
            },
          ],
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_INDIVIDUAL_REMOVE: {
      const { index, role } = payload;

      return {
        ...state,
        commissionValuesForIndividual: {
          ...state.commissionValuesForIndividual,
          [role]: state.commissionValuesForIndividual[role].filter((a, i) => i !== index),
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP: {
      const { index, role, value, key, tierIndex, userId } = payload;
      const tiersUpdated = set(
        state.tiers,
        `[${tierIndex}].commissionValuesForUserGroup.${role}[${index}].${key}`,
        value,
      );

      const newState = {
        ...state,
        tiers: tiersUpdated,
      };

      if ('user' === key) {
        const usersWithCommissionsUpdated = set(state.usersWithCommissions, `${value.id}.${role}[${tierIndex}]`, {
          value: 0,
          index,
        });
        newState.usersWithCommissions = usersWithCommissionsUpdated;
      } else if ('amount' === key && userId) {
        const usersWithCommissionsUpdated = set(state.usersWithCommissions, `${userId}.${role}[${tierIndex}]`, {
          value: parseInt(value),
          index,
        });
        newState.usersWithCommissions = usersWithCommissionsUpdated;
      }

      return newState;
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_ADD: {
      const { role, tierIndex } = payload;
      const tempTiers = [...state.tiers];
      tempTiers[tierIndex].commissionValuesForUserGroup[role].push({
        amount: 0,
        user: null,
      });
      return {
        ...state,
        tiers: tempTiers,
      };
    }
    case CREATE_SHIFT_COMMISSION_USER_GROUP_REMOVE: {
      const { index, role, tierIndex, userId } = payload;
      const tempTiers = [...state.tiers];

      const usersWithCommissionsUpdated = set(
        state.usersWithCommissions,
        `${userId}.${role}[${tierIndex}]`,
        undefined,
      );

      if (usersWithCommissionsUpdated[userId][role].filter((c) => !!c).length === 0) {
        delete usersWithCommissionsUpdated[userId][role];
      }

      if (Object.keys(usersWithCommissionsUpdated[userId]).length === 0) {
        delete usersWithCommissionsUpdated[userId];
      }

      tempTiers[tierIndex].commissionValuesForUserGroup[role].splice(index, 1);

      return {
        ...state,
        tiers: tempTiers,
        usersWithCommissions: usersWithCommissionsUpdated,
      };
    }
    case CREATE_SHIFT_COMMISSION_PER_VEHICLE: {
      const { index, role, value, key } = payload;
      const updated = set(state.commissionValuesPerVehicle, `${role}[${index}].${key}`, value);
      return {
        ...state,
        commissionValuesPerVehicle: updated,
      };
    }
    case CREATE_SHIFT_COMMISSION_PER_VEHICLE_ADD: {
      const { role } = payload;
      return {
        ...state,
        commissionValuesPerVehicle: {
          ...state.commissionValuesPerVehicle,
          [role]: [...state.commissionValuesPerVehicle[role], { involuntary: 0, voluntary: 0, user: null }],
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_PER_VEHICLE_REMOVE: {
      const { index, role } = payload;
      return {
        ...state,
        commissionValuesPerVehicle: {
          ...state.commissionValuesPerVehicle,
          [role]: state.commissionValuesPerVehicle[role].filter((a, i) => i !== index),
        },
      };
    }
    case CREATE_SHIFT_COMMISSION_ADD_TIER: {
      const updatedTier = [];
      for (let i = 0; i < Number(state.noOfUsersOnShift); i++) {
        updatedTier.push({ voluntary: null, involuntary: null });
      }

      const commissionValuesForUserGroup = {
        'Branch Manager': [],
        'Recovery Agent': [],
        Investigator: [],
        'Camera Car': [],
        Spotter: [],
        Administrator: [],
        'Customer Rep': [],
      };

      for (let i = 0; i < state.tiers.length; i += 1) {
        const tier = state.tiers[i];
        const roleList = Object.keys(tier.commissionValuesForUserGroup);
        for (let j = 0; j < roleList.length; j += 1) {
          const role = roleList[j];
          if (tier.commissionValuesForUserGroup[role].length) {
            if (commissionValuesForUserGroup[role].length === 0) {
              commissionValuesForUserGroup[role].push({
                amount: tier.commissionValuesForUserGroup[role][0].amount,
                user: 'all',
              });
            } else {
              const previousValue = commissionValuesForUserGroup[role][0].amount;
              commissionValuesForUserGroup[role][0].amount = Math.max(
                previousValue,
                tier.commissionValuesForUserGroup[role][0].amount,
              );
            }
          }
        }
      }

      return {
        ...state,
        tiers: [
          ...state.tiers,
          {
            data: updatedTier,
            commissionValuesForUserGroup,
          },
        ],
      };
    }
    case CREATE_SHIFT_COMMISSION_REMOVE_TIER: {
      let updatedTier = [...state.tiers];

      if (state.tiers.length > 1) {
        updatedTier = state.tiers.filter((a, i) => i !== payload.index);
      }
      return {
        ...state,
        tiers: updatedTier,
        tierErrors: [],
      };
    }
    case CREATE_SHIFT_COMMISSION_CHANGE_TIER_VALUE: {
      const { index, key, innerIndex, value } = payload;
      const updatedTireErrors = getTiersError(key, index, innerIndex, state.tiers, value, state.tierErrors);
      const updated = set(state.tiers, `[${index}].data[${innerIndex}].${key}`, value);
      return {
        ...state,
        tiers: updated,
        tierErrors: updatedTireErrors,
      };
    }
    case CREATE_NEW_STEP_FILLED: {
      return {
        ...state,
        stepsFilled: [...state.stepsFilled, ...(state.stepsFilled.indexOf(payload) === -1 ? [payload] : [])],
      };
    }
    case CREATE_SHIFT_SET_EXISTING_DATA: {
      return {
        ...state,
        ...payload,
      };
    }
    case CREATE_SHIFT_RESET_STATE: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
};

export { initialState };
